import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchJourneyShare } from '../lib/programsApi';

const SERIF = { fontFamily: "'Playfair Display', serif" };

export default function JourneySharePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { fetchJourneyShare(token).then(setD).catch(() => setErr('This shared journey is no longer available.')); }, [token]);
  if (err) return <div className="px-5 py-16 text-center text-[#e3d2a8]" data-testid="journey-share-unavailable"><p>{err}</p><button onClick={() => navigate('/programs')} className="mt-4 px-5 py-2.5 btn-gold rounded-full text-sm font-semibold">Explore journeys</button></div>;
  if (!d) return <div className="px-5 pt-8"><div className="aspect-[4/5] rounded-3xl bg-white/10 animate-pulse" /></div>;
  return (
    <div className="px-5 py-8 max-w-md mx-auto text-center animate-fade-in" data-testid="journey-share-page">
      <img src={d.imageUrl} alt={`${d.headline} — Reflections by Rowdy journey postcard`} className="w-full rounded-3xl shadow-2xl" data-testid="journey-share-image" />
      <h1 className="text-2xl font-bold text-[#f9f4ea] mt-5" style={SERIF} data-testid="journey-share-title">{d.title}</h1>
      <p className="text-sm text-[#e3d2a8]/90 mt-1">{d.description}</p>
      <button onClick={() => navigate(`/programs/${d.programSlug}`)} className="mt-6 h-12 px-6 rounded-full bg-[#D6AD60] text-[#0f1e33] text-xs font-semibold uppercase tracking-[0.2em]" data-testid="journey-share-cta">Begin this journey</button>
    </div>
  );
}
